module.exports = __webpack_public_path__ + "assets/img/17.2bf7d304.png";